export default {
  getProjectList: "mappingURL",
  getProjectDetail: "mappingURL",
  setProject: "mappingURL/create",
  updateProject: "mappingURL/update",
  updateMultiProject: "mappingURL/multiUpdate",
  deleteProject: "mappingURL/delete",
  authOCT: "/auth/otc",
  authVerify: "/auth/otc/verify",
};
